import { apolloApi } from "@/shared/api";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { AgentQueryParams } from "@suns/api/generated-client/apollo/models/AgentQueryParams";

export async function agenciesLoader() {
  const response = await apolloApi.getAgencies({});
  return response;
}

export async function agentsLoader({
  offset,
  limit,
  sortColumn,
  sortDir,
  agencyId,
}: AgentQueryParams) {
  const response = await apolloApi.getAgents({
    offset,
    limit,
    sortColumn,
    sortDir,
    agencyId,
  });
  return response;
}

export async function agentByIdLoader({ id }: { id: number }) {
  if (!id) {
    return;
  }

  const response = await apolloApi.getAgentById(id);

  return response;
}
